import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const PurchasedTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.purchased-folder-title" />;
